import styled, { css } from 'styled-components';
import Input from '../../newComponents/UnformInput';

import PrimitiveModal from '../../newComponents/Modal';

type SortableItemProps = {
  active: boolean;
};

export const Container = styled.div`
  padding: 50px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;

  @media only screen and (max-width: 1440px) {
    padding: 30px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1500px;
  width: 100%;
  position: relative;
`;

export const PageHeaderActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 20px;

  .form {
    display: flex;
    gap: 5px;
    flex-direction: column;

    @media (min-width: 500px) {
      display: grid;
      grid-template-columns: 250px 1fr;
      grid-template-rows: 1fr;
      column-gap: 15px;
    }
  }

  > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      svg {
        margin-right: 10px;
      }
    }

    p {
      font-family: 'Sora', sans-serif;
      display: flex;
      align-items: center;
      color: #329bfc;
      letter-spacing: 0px;
      cursor: pointer;

      svg {
        font-size: 24px;
        margin-right: 5px;
      }

      span {
        font-size: 14px;
        font-weight: 500;
        text-decoration: underline;
        color: #329bfc;
      }
    }
  }

  /* > div:last-child {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: 1fr;
    column-gap: 15px;
  } */
`;

export const Accordions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Modal = styled(PrimitiveModal)`
  position: relative;
  padding: 28px 32px;
  border-radius: 8px;
  font-family: 'Sora', sans-serif;
  max-height: calc(100% - 72px);
  overflow: auto;
`;

export const ModalHeader = styled.div`
  text-align: center;

  h1,
  h2 {
    color: #101d40;
    font-size: 24px;
    font-weight: 800;
  }

  h3,
  p {
    color: #7c8db5;
  }

  h3 {
    margin-top: 8px;
    font-size: 16px;
  }

  p {
    margin-top: 3px;
    font-size: 15px;
  }
`;

export const SortableContainer = styled.div`
  width: 100%;
  max-width: 720px;
  margin-top: 15px;
  border: 2px solid #e6effb;
  border-radius: 5px;
`;

export const SortableHeader = styled.div<{
  column: 'grupos' | 'complementos' | 'produtos' | 'itens';
}>`
  display: flex;

  div {
    flex: 1;
    padding: 15px;
    text-align: center;
    border-bottom: 2px solid #e6effb;

    h2 {
      color: #101d40;
      font-size: 16px;
      font-weight: 600;
    }

    &:not(:last-child) {
      border-right: 2px solid #e6effb;
    }
  }

  .grupos,
  .complementos,
  .produtos,
  .itens,
  .icon {
    position: relative;
  }

  .icon {
    display: none;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 5px;
    border: initial !important;
    border-radius: 50%;
    outline: 2px solid #329bfc;
    color: #329bfc;
    font-size: 20px;

    :hover {
      outline: initial;
      background: #329bfc;
      color: #fff;
    }
  }

  @media (max-width: 767px) {
    .grupos {
      display: ${(p) => (p.column === 'grupos' ? 'initial' : 'none')};
    }

    .complementos {
      display: ${(p) => (p.column === 'complementos' ? 'initial' : 'none')};
    }

    .produtos {
      display: ${(p) => (p.column === 'produtos' ? 'initial' : 'none')};
    }

    .itens {
      display: ${(p) => (p.column === 'itens' ? 'initial' : 'none')};
    }

    .icon {
      display: flex;
    }
  }
`;

export const SortableContent = styled.div<{
  column: 'grupos' | 'complementos' | 'produtos' | 'itens';
}>`
  display: flex;

  @media (max-width: 767px) {
    #grupos {
      display: ${(p) => (p.column === 'grupos' ? 'initial' : 'none')};
    }

    #complementos {
      display: ${(p) => (p.column === 'complementos' ? 'initial' : 'none')};
    }

    #produtos {
      display: ${(p) => (p.column === 'produtos' ? 'initial' : 'none')};
    }

    #itens {
      display: ${(p) => (p.column === 'itens' ? 'initial' : 'none')};
    }
  }
`;

export const SortableColumn = styled.div`
  overflow: auto;
  flex: 1;
  height: 350px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border: 0px none #ffffff;
    border-radius: 50px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }

  &::-webkit-scrollbar-thumb:active {
    background-color: #8a8a8a;
  }

  &::-webkit-scrollbar-track {
    background: #ededed;
    border: 0px none #ffffff;
  }

  &::-webkit-scrollbar-track:hover {
    background: #ededed;
  }

  &::-webkit-scrollbar-track:active {
    background: #ededed;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &:not(:last-child) {
    border-right: 2px solid #e6effb;
  }
`;

export const SortableItem = styled.button<SortableItemProps>`
  background-color: #ffffff;
  display: flex;
  width: 100%;
  border: none;
  outline: none;
  align-items: center;
  justify-content: flex-start;
  text-align: start;
  padding: 12px 10px;
  border-bottom: 1px solid #e6effb;
  color: #101d40;

  svg:not(.right_arrow) {
    font-size: 17px;
    margin-right: 5px;
    cursor: grab;
  }

  p {
    font-size: 13px;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  &:hover {
    background-color: #eeeeee;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: #f2f2f2;

      p {
        font-weight: 600;
      }
    `};
`;

export const GroupTypeItems = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 25px;
  justify-content: center;
  align-items: center;
`;

export const GroupTypeItem = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 151px;
  border-radius: 8px;
  padding: 9px;
  border: 2px solid #e6effb;
  background-color: #ffffff;
  font-family: 'Sora', sans-serif;
  transition: all 0.2s ease;

  svg {
    font-size: 40px;
    color: #329bfc;
    margin-bottom: 15px;
  }

  h3 {
    font-size: 14px;
    font-weight: 600;
    color: #101d40;
  }

  p {
    margin-top: 8px;
    font-size: 13px;
    color: #7c8db5;
  }

  &:hover:not(:disabled) {
    border-color: #329bfc;
  }

  &:disabled {
    cursor: not-allowed;
    border-color: rgba(16, 16, 16, 0.1);

    h3,
    p,
    svg {
      color: rgba(16, 16, 16, 0.3);
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 15px;
  gap: 15px;

  button {
    &:first-child {
      width: 150px;
    }

    &:last-child {
      width: 220px;
    }
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(215, 222, 233, 0.25);

  svg {
    color: #4f4f4f;
    font-size: 22px;
  }

  &:hover {
    background-color: rgba(215, 222, 233, 0.5);
  }
`;

export const CustomInput = styled(Input)<{
  codeIsValid: boolean;
}>`
  &:focus {
    ${(props) => {
      return (
        props.codeIsValid &&
        css`
          color: #04aa6d !important;
          border-color: #04aa6d !important;
        `
      );
    }}
  }
`;
